import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
const PrimePageTranslationsPageProvider = createTranslationsPageProvider({
  prime: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-prime/translations/${brand}/${locale}/dynpack_membership-page.js`)
});
export default PrimePageTranslationsPageProvider;